import { Table, Checkbox, Text } from '@chakra-ui/react';
import {
  ContactMethod,
  ResultStatus,
  CONTACT_METHOD_LABELS,
  RESULT_STATUS_LABELS,
} from '../../types/script'
import type { CanvasResultSettingsFormState } from '../../types/script'

interface ResultSettingsGridProps {
  resultSettings: CanvasResultSettingsFormState[]
  onChange: (updated: CanvasResultSettingsFormState[]) => void
}

// Door is edited by OutcomeSettingsEditor (spec §5.3).
const allContactMethods = [
  ContactMethod.Phone,
  ContactMethod.Event,
  ContactMethod.Text,
  ContactMethod.Email,
]

const allResultStatuses = [
  ResultStatus.Completed,
  ResultStatus.Busy,
  ResultStatus.NoAnswer,
  ResultStatus.LeftMessage,
  ResultStatus.Moved,
  ResultStatus.Refused,
  ResultStatus.Callback,
]

export function ResultSettingsGrid({
  resultSettings,
  onChange,
}: ResultSettingsGridProps) {
  const handleToggle = (
    contactMethod: ContactMethod,
    resultStatus: ResultStatus
  ) => {
    onChange(
      resultSettings.map((rs) => {
        if (rs.contactMethod !== contactMethod) return rs
        const has = rs.allowedResults.includes(resultStatus)
        return {
          ...rs,
          allowedResults: has
            ? rs.allowedResults.filter((r) => r !== resultStatus)
            : [...rs.allowedResults, resultStatus],
        }
      })
    )
  }

  const isChecked = (
    contactMethod: ContactMethod,
    resultStatus: ResultStatus
  ): boolean => {
    const setting = resultSettings.find(
      (rs) => rs.contactMethod === contactMethod
    )
    return setting?.allowedResults.includes(resultStatus) ?? false
  }

  return (
    <Table.Root size="sm">
      <Table.Header bg="bg.subtle">
        <Table.Row>
          <Table.ColumnHeader>Contact Method</Table.ColumnHeader>
          {allResultStatuses.map((status) => (
            <Table.ColumnHeader key={status} textAlign="center" px={2}>
              <Text fontSize="xs">{RESULT_STATUS_LABELS[status]}</Text>
            </Table.ColumnHeader>
          ))}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {allContactMethods.map((method) => (
          <Table.Row key={method}>
            <Table.Cell>
              <Text fontWeight="medium" fontSize="sm">
                {CONTACT_METHOD_LABELS[method]}
              </Text>
            </Table.Cell>
            {allResultStatuses.map((status) => (
              <Table.Cell key={status} textAlign="center" px={2}>
                <Checkbox.Root
                  size="sm"
                  onCheckedChange={() => handleToggle(method, status)}
                  checked={isChecked(method, status)}><Checkbox.HiddenInput /><Checkbox.Control><Checkbox.Indicator /></Checkbox.Control></Checkbox.Root>
              </Table.Cell>
            ))}
          </Table.Row>
        ))}
      </Table.Body>
    </Table.Root>
  );
}
